<template>
    <v-menu offset-y v-model="userMenu" :close-on-content-click="false" :nudge-width="200" offset-x>
        <template v-slot:activator="{ on: activationEvents }">
            <v-tooltip :disabled="utils.isMobile()" :color="$vuetify.theme.dark ? '#5F6673' : '#9e9e9e'" open-delay="500" bottom>
                <template v-slot:activator="{ on }">
                    <span v-on="on">
                        <v-btn
                            tag="a"
                            class="link-menu"
                            :height="$vuetify.breakpoint.xs ? 30 : 46"
                            min-width="30"
                            :width="$vuetify.breakpoint.xs ? 30 : 50"
                            text
                            v-on="activationEvents"
                            @click="resetFormValidation"
                        >
                            <v-icon :color="$vuetify.theme.dark ? '' : '#867878'">mdi-account-box-outline</v-icon>
                        </v-btn>
                    </span>
                </template>
                <span class="menuable__content__active-enter-active">
                    {{ $t('menu.account') }}
                </span>
            </v-tooltip>
        </template>

        <v-card v-if="user" width="350px" outlined>
            <AppMenuAccountChangeSettings></AppMenuAccountChangeSettings>

            <v-card-text class="py-2">
                <v-container class="font14 pl-4 pr-0">
                    <v-row>
                        <v-col cols="12" class="py-2 pl-1">
                            <span @click="showChangeOrderSettingsDialog" class="cursorPointer lightGreyText">
                                <v-icon class="pr-2" style="margin-bottom: 2px">mdi-cog-outline</v-icon>
                                {{ $t('menu.orderSettings') }}
                            </span>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <!--            <AppMenuAccountChangeOrderSettingsDialog-->
            <!--                ref="changeOrderSettingsDialog"-->
            <!--            ></AppMenuAccountChangeOrderSettingsDialog>-->

            <AppMenuAccountChangeLocaleAndTimeZone></AppMenuAccountChangeLocaleAndTimeZone>
        </v-card>
    </v-menu>
</template>
<style scoped></style>
<script>
    import { mapGetters } from 'vuex';
    import AppMenuAccountChangeLocaleAndTimeZone from './AppMenuAccountChangeLocaleAndTimeZone';
    import AppMenuAccountChangeOrderSettingsDialog from './AppMenuAccountChangeOrderSettingsDialog';
    import AppMenuAccountChangeSettings from './AppMenuAccountChangeSettings';

    export default {
        name: 'app-menuAccountWL',
        components: {
            AppMenuAccountChangeLocaleAndTimeZone,
            AppMenuAccountChangeSettings,
            AppMenuAccountChangeOrderSettingsDialog,
        },

        created: function () {
            console.log('Component %s was created.', this.$options.name);
        },

        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },

        methods: {
            resetFormValidation() {
                if (this.$refs.setTimeZoneForm) {
                    this.$refs.setTimeZoneForm.$refs.form.resetValidation();
                }
            },
            showChangeOrderSettingsDialog() {
                this.$parent.$parent.$parent.$parent.$parent.$refs.changeOrderSettingsDialog.open();
            },
        },

        computed: {
            ...mapGetters({
                getTimeZone: 'DictionariesModule/getTimeZone',
            }),
            userMenu: {
                get() {
                    return this.$store.getters['MenuModule/getUserMenu'];
                },
                set(value) {
                    this.$store.commit('MenuModule/setUserMenu', value);
                },
            },
            user() {
                return this.$store.getters['UserModule/getUser'];
            },
        },
    };
</script>
